module.exports = "/images/_/_/_/_/build/resources/js/src/assets/images/profile/post-media/25.jpg";